import styled from '@emotion/styled';
import { Card, isMobile, isSmallMobile, rem } from '@triumph/design-system';
import { BreakpointProps } from './common.types';

export const StyledCard = styled(Card)`
  padding: ${rem(24)} ${rem(19)} 0 ${rem(14)};
`;
export const Container = styled.div<BreakpointProps>`
  display: flex;
  justify-content: space-between;
  ${({ breakpoint }) => !isSmallMobile(breakpoint) && `gap: ${rem(24)}`};
  flex-direction: ${({ breakpoint }) =>
    isMobile(breakpoint) ? 'column' : 'row'};
`;
export const StyledDetailCard = styled(Card)`
  padding: ${rem(32)};
`;
